<template>
  <Submenu :name="parentItem.projectId + '-' + parentItem.id">
    <!-- 一级目录 -->
    <template slot="title">
      <Icon :custom="'i-custom icon-' + parentItem.icon" :size="iconSize" />
      <span class="layout-text"
        >{{ parentItem.title }}
        <add-dashboard
          v-if="parentItem.name === 'Dashboard' && userGroupId != 4"
          style="margin-left: 50px"
        ></add-dashboard>
      </span>
    </template>
    <!-- 二级目录 -->
    <template v-for="child in parentItem.children">
      <!-- 他人分享概览 -->
      <side-menu-item
        v-if="child.children && child.children.length > 0"
        :iconSize="iconSize"
        :parentItem="child"
        :key="'menu' + child.id"
      >
      </side-menu-item>
      <!-- 所有的二级目录 -->
      <MenuItem v-else :key="child.id" :name="child.id + '-' + child.name" :title="child.title">
        <!-- 5
      event_analysis -->
        <!-- :name="child.id + '-' + child.name" -->
        <Icon
          :custom="'i-custom icon-' + child.icon"
          :size="iconSize"
          :key="child._uid"
        />
        <span class="layout-text" :key="'title' + child.id">{{
          child.title
        }}</span>
      </MenuItem>
    </template>
  </Submenu>
</template>

<script>
import addDashboard from "@/views/dashboards/add-dashboard";
import { mapState, mapMutations } from "vuex";

export default {
  name: "side-menu-item",
  components: {
    addDashboard,
  },
  computed: {
    ...mapState({
      userGroupId: (state) => state.user.userGroupId,
    }),
  },
  props: {
    parentItem: {
      type: Object,
      default: () => ({}),
    },
    index: Number,
    iconSize: Number,
  },
  methods: {},
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/main-components/shrinkable-menu/components/side-menu-item.vue